import { useListenerMiddleware } from '../../hooks/useListenerMiddleware';
import { requestExcelPendingListenerOptions as requestExcelPendingListener } from '../../store/middlewares/export';
import {
  activateDraftCatalogListenerOptions as activateDraftCatalogListener,
  catalogDeletedListenerOptions as catalogDeletedListener,
} from '../../store/slices/catalog/listeners';
import { categoryReceivedListenerOptions as categoryReceivedListener } from '../../store/slices/category/listeners';
import { draftStatusReceivedListenerOptions as draftStatusReceivedListener } from '../../store/slices/draftstatus/listeners';
import { itemsReceivedListenerOptions as itemsReceivedListener } from '../../store/slices/item/listeners';
import { paneSetSourceListenerOptions as paneSetSourceListener } from '../../store/slices/pane/listeners';
import {
  clearSearchListenerOptions as clearSearchListener,
  searchMoveListenerOptions as searchMoveListener,
  searchNavigationListenerOptions as searchNavigationListener,
  searchUpdateListenerOptions as searchUpdateListener,
  setSearchConditionListenerOptions as setSearchConditionListener,
  toggleSearchPanelListenerOptions as toggleSearchPanelListener,
  treeActionsListenerOptions as treeActionsListener,
  treeExpandNodeListenerOptions as treeExpandNodeListener,
  treeSearchBySuggestionIdListenerOptions as treeSearchBySuggestionIdListener,
  treeSearchListenerOptions as treeSearchListener,
  treeUpdateDataListenerOptions as treeUpdateDataListener,
} from '../../store/slices/tree/listeners';

const MiddlewareWrapper = function MiddlewareWrapper({ children }) {
  useListenerMiddleware(activateDraftCatalogListener);
  useListenerMiddleware(catalogDeletedListener);
  useListenerMiddleware(categoryReceivedListener);
  useListenerMiddleware(draftStatusReceivedListener);
  useListenerMiddleware(itemsReceivedListener);
  useListenerMiddleware(paneSetSourceListener);
  useListenerMiddleware(requestExcelPendingListener);
  useListenerMiddleware(clearSearchListener);
  useListenerMiddleware(searchMoveListener);
  useListenerMiddleware(searchNavigationListener);
  useListenerMiddleware(searchUpdateListener);
  useListenerMiddleware(setSearchConditionListener);
  useListenerMiddleware(toggleSearchPanelListener);
  useListenerMiddleware(treeActionsListener);
  useListenerMiddleware(treeExpandNodeListener);
  useListenerMiddleware(treeSearchBySuggestionIdListener);
  useListenerMiddleware(treeSearchListener);
  useListenerMiddleware(treeUpdateDataListener);
  return children;
};

export default MiddlewareWrapper;
